import { MouseEventHandler, ReactNode } from "react";
import { Button as DSButton } from "@boostdev/design-system-components";

interface ButtonProps {
  href?: string;
  variant?: "primary" | "secondary";
  type?: "button" | "submit" | "reset";
  prefix?: ReactNode;
  suffix?: ReactNode;
  children?: ReactNode;
  className?: string;
  disabled?: boolean;
  onClick?: MouseEventHandler<HTMLElement>;
  ["aria-label"]?: string;
}

export function Button({
  children,
  className,
  variant = "primary",
  type = "button",
  prefix,
  suffix,
  href,
  disabled,
  onClick,
  ...rest
}: Readonly<ButtonProps>) {
  return (
    <DSButton
      variant={variant === "secondary" ? "outline" : "default"}
      type={type}
      href={href}
      disabled={disabled}
      onClick={onClick}
      iconStart={prefix}
      iconEnd={suffix}
      className={className}
      {...rest}
    >
      {children}
    </DSButton>
  );
}
